"use strict";
/*
 * Permissions management system, define access level for each of
 * your server apis, and restrict users by giving them access levels
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModulePackFE_Permissions = void 0;
const ModuleFE_PermissionsUser_1 = require("../modules/assign/ModuleFE_PermissionsUser");
const ModuleFE_PermissionsGroup_1 = require("../modules/assign/ModuleFE_PermissionsGroup");
const ModuleFE_PermissionsProject_1 = require("../modules/manage/ModuleFE_PermissionsProject");
const ModuleFE_PermissionsDomain_1 = require("../modules/manage/ModuleFE_PermissionsDomain");
const ModuleFE_PermissionsAccessLevel_1 = require("../modules/manage/ModuleFE_PermissionsAccessLevel");
const ModuleFE_PermissionsApi_1 = require("../modules/manage/ModuleFE_PermissionsApi");
const ModuleFE_PermissionsAssert_1 = require("../modules/ModuleFE_PermissionsAssert");
exports.ModulePackFE_Permissions = [
    ModuleFE_PermissionsUser_1.ModuleFE_PermissionsUser,
    ModuleFE_PermissionsGroup_1.ModuleFE_PermissionsGroup,
    ModuleFE_PermissionsProject_1.ModuleFE_PermissionsProject,
    ModuleFE_PermissionsDomain_1.ModuleFE_PermissionsDomain,
    ModuleFE_PermissionsAccessLevel_1.ModuleFE_PermissionsAccessLevel,
    ModuleFE_PermissionsApi_1.ModuleFE_PermissionsApi,
    ModuleFE_PermissionsAssert_1.ModuleFE_PermissionsAssert,
];
__exportStar(require("../modules/assign/ModuleFE_PermissionsUser"), exports);
__exportStar(require("../modules/assign/ModuleFE_PermissionsGroup"), exports);
__exportStar(require("../modules/manage/ModuleFE_PermissionsProject"), exports);
__exportStar(require("../modules/manage/ModuleFE_PermissionsDomain"), exports);
__exportStar(require("../modules/manage/ModuleFE_PermissionsAccessLevel"), exports);
__exportStar(require("../modules/manage/ModuleFE_PermissionsApi"), exports);
